import { useAdministrativeContext } from '../../../../../../../../pages/administrativePanel/administrativePanelContext'
import { FaTimesCircle, FaCaretDown } from 'react-icons/fa'
import { useState } from 'react'
import { Business } from '../Business'

import { Container } from './style'


export function State({ state }) {
    const { removingFromArrayBusiness } = useAdministrativeContext()
    const [openState, setOpenState] = useState(false)

    function removingStateFromFilter(business) {
        let idListBusiness = business.map(b => b.id)

        removingFromArrayBusiness(idListBusiness)
    }

    return(
        <Container openState={openState}>
            <div className='text'>
                <p onClick={() => setOpenState(!openState)}>
                    {state.state}
                </p>

                <div className='buttonsActions'>
                    <FaTimesCircle 
                        className='cleanStateButton'
                        onClick={() => removingStateFromFilter(state.business)}
                    />

                    <FaCaretDown 
                        className='openButtonState'
                        onClick={() => setOpenState(!openState)}
                    />
                </div>
            </div>


            {openState &&
                <Business 
                    businesses={state.business}
                />
            }
        </Container>
    )
}
